module.exports = ".wizard-padding {\n  padding-left: 220px; }\n"